<template>
  <div>
    <b-breadcrumb
      v-if="pageStatus == '1'"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{ $t("dashboard") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-breadcrumb
      v-else
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType != '/tasks'"
        to="/manage-employee"
      >{{ $t("manageEmployee") }}</b-breadcrumb-item>
      <b-breadcrumb-item :to="$store.state.selectedTaskType">{{ $t("employeeProfile") }}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoading"
      class="text-center"
    />
    <div
      v-else
      class="m-0"
    >
      <div
        id="exam"
        v-if="startExam"
      >
        <div v-if="showTimer">
          Time left :
          <span style="font-size:40px;">
            <strong>{{examPresentTime}}</strong>
          </span>
        </div>
        <b-row class="mb-4 pt-2">
          <b-col
            cols="3"
            class="pr-0 pl-4"
          >
            <div class="mt-5">
              <div
                class="first"
                style="max-width: 15rem !important;"
              ></div>
              <div
                id="talkbubble"
                style="max-width: 15rem !important;"
              >
                <h1>Question {{currentQuestionIndex+1}}</h1>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <b-row>
              <b-card
                header-class="exam-card-header"
                class="mb-3"
                style="height: calc(100vh - 170px); width:100%;"
              >
                <template v-slot:header>
                  <h3 class="mb-0 text-left">
                    <b-badge variant="dark">Q{{currentQuestionIndex+1}}</b-badge>
                    &nbsp;{{currentQuestion}}
                  </h3>
                </template>
                <div
                  class="text-left animate-slide-from-left"
                  v-if="currentAnswerType == 1"
                >
                  <b-form-group
                    v-for="(answer,answerIndex) in currentAnswers "
                    :key="answerIndex"
                  >
                    <b-form-radio
                      v-model="selectedRadioAns"
                      :value="answer.answer"
                      @change="setAnswer($event, answerIndex, 'radio'),autoNextQuestion()"
                    >{{answer.answer}}</b-form-radio>
                  </b-form-group>
                </div>

                <!-- for Checkboxes type quiestions -->
                <div
                  class="text-left animate-slide-from-left"
                  v-if="currentAnswerType == 2"
                >
                  <b-form-group
                    v-for="(answer,index) in currentAnswers "
                    :key="index"
                  >
                    <b-form-checkbox
                      v-model="selectedCheckboxAns"
                      :value="answer.answer"
                      @change="setAnswer($event, index, 'checkbox'),autoNextQuestion()"
                    >{{answer.answer}}</b-form-checkbox>
                  </b-form-group>
                </div>

                <!-- for Buttons type quiestions -->
                <b-form-group
                  class="text-left animate-slide-from-left"
                  v-if="currentAnswerType == 3"
                >
                  <b-button
                    pill
                    :variant="selectedButtonAns == answer.answer  ? 'primary' : 'outline-primary' "
                    class="mr-3"
                    v-for="(answer,index) in currentAnswers "
                    :key="index"
                    @click="setAnswer(answer, index, 'button'),autoNextQuestion()"
                  >{{answer.answer}}</b-button>
                </b-form-group>
              </b-card>
            </b-row>
            <b-row>
              <b-col
                class="text-left"
                cols="5"
              >
                <div>
                  <b-button-group>
                    <b-button
                      variant="outline-danger"
                      v-b-modal.modal-3
                    >Cancel</b-button>
                    <b-button
                      variant="outline-primary"
                      :disabled="inTransistion"
                      v-if="currentQuestionIndex != 0"
                      @click="previousQuestion"
                    >Back to Q{{currentQuestionIndex}}</b-button>
                  </b-button-group>
                </div>
              </b-col>
              <b-col cols="2">
                <span>
                  Viewing:
                  <b-badge variant="dark">{{currentQuestionIndex+1 +'/'+questions.length}}</b-badge>
                </span>
              </b-col>
              <b-col
                cols="5"
                class="text-right"
              >
                <div>
                  <b-button-group>
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="nextQuestion"
                      v-if="(currentQuestionIndex+1) != questions.length"
                    >Next</b-button>
                    <b-button
                      v-if="(currentQuestionIndex+1) == questions.length"
                      :disabled="inTransistion"
                      variant="outline-success"
                      @click="isAllowBlankAns ? $bvModal.show('modal-1') : onValidateExam()"
                    >Submit Answers</b-button>
                    <!-- v-b-modal.modal-1 -->
                  </b-button-group>
                </div>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="3">
            <h4>Answer Overview</h4>
            <div style="height: calc(100vh - 110px); overflow:auto;">
              <b-list-group
                v-for="(question,index) in selectedAnswersForExams"
                :key="index"
              >
                <b-list-group-item class="text-left">
                  <b-badge variant="outline-light">Q{{(index+1)}}</b-badge>
                  <span class="text-danger float-right">
                    <b-badge
                      v-if="currentQuestionIndex >= index || question.viewed"
                      class="mr-2"
                      variant="primary"
                    >Viewed</b-badge>
                    <b-badge
                      v-if="question.answer"
                      variant="dark"
                    >Answered</b-badge>
                    <b-badge
                      v-else
                      variant="danger"
                    >Not answered</b-badge>
                  </span>
                  <span class="text-danger"></span>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        class="my-5"
        v-else
      >
        <h1 class="mb-3">{{formTitle}}</h1>
        <p
          v-html="sanitizeHtml(pageIntroText)"
          class="mb-2"
        ></p>

        <p>
          <strong>Guidance</strong>
        </p>
        <p>Ensure you have read the appropiate learning material before completing the exam. This exam will take around {{examTimeLimit}} minutes.</p>
        <p>
          <strong>Summary</strong>
        </p>
        <p v-if="examTimeLimit  > 0">This is a {{examTimeLimit}} minute timed exam</p>
        <p v-if="examAttemptsLimit >0 ">You have a total of {{examAttemptsLimit}} attempts for the entire exam and its questions</p>
        <p v-if="isExamUnlimitedAttempts == true || examAttemptsLimit > 0">Attempts to date: {{examAttemptsToDate}}</p>
        <p v-if="examAttemptsLimit > 0">Remaining Attempts: {{examAttemptsLimit - examAttemptsToDate >= 0 ? examAttemptsLimit - examAttemptsToDate : 0}}</p>
        <p
          v-if="(examAttemptsLimit - examAttemptsToDate) <= 0"
          class="text-danger"
        >
          <span v-if="isExamUnlimitedAttempts == !true">You have reached the maximum number of attempts. Please contact the compliance officer to discuss your options</span>
        </p>
        <b-button
          v-if="isExamUnlimitedAttempts == true || (examAttemptsLimit - examAttemptsToDate) > 0"
          variant="outline-primary"
          class="mr-2"
          v-b-modal.modal-2
          @click="onTimerSet(true)"
        >START NOW</b-button>

        <!-- to="/dashboard" -->

        <b-button
          @click="onBack"
          v-if="isExamUnlimitedAttempts == true || (examAttemptsLimit - examAttemptsToDate) > 0"
        >I'll do it later</b-button>
        <b-button
          @click="onBack"
          v-else
        >Go Back</b-button>
      </div>
    </div>

    <b-modal
      id="modal-2"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      title="Start Exam"
    >
      <p class="my-4">Your exam is about to start in {{countDown}} seconds</p>
      <template v-slot:modal-footer>
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="success"
          @click="startExamImmediately"
        >Start Immediately</b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          @click="onTimerSet(false)"
        >Cancel</b-button>
      </template>
    </b-modal>

    <!-- review modal -->
    <b-modal
      id="modal-1"
      modal-header-close="No"
      ok-title="Submit"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      title="Submit Exam"
      @ok="submitAnswers"
    >
      <p>You are about to submit your answers. This will count towards the maximum attempts. If you are happy with your answers then submit.</p>
      <p>
        <strong>Note:</strong> You can go back and review your answers before you submit.
      </p>
      <ul
        v-for="(ans, index) in this.selectedAnswersForExams"
        :key="index"
      >
        <li>Question {{index+1}}: {{ans.answer || 'No Answer Given'}}</li>
      </ul>
    </b-modal>
    <b-modal
      id="modal-3"
      title="Cancel Exam"
      @ok="onCancelExam"
    >
      <p class="my-4">
        Are you sure you would like to cancel without completing your exam?
        <span v-if="isExamUnlimitedAttempts == !true">
          Cancelling the exam would count towards your attempts.
          You have {{(examAttemptsLimit - examAttemptsToDate)}} attempt(s) remaining
        </span>
      </p>
    </b-modal>

    <!-- modal will show all submited answers -->
    <b-modal
      id="modal-submitted"
      no-close-on-esc
      no-close-on-backdrop
      no-enforce-focus
      hide-header-close
      scrollable
      ok-only
      ok-title="Close"
      title="Exam Submitted"
      @hidden="onBack"
    >
      <!-- @hidden="$router.push('/dashboard')" -->

      <p>Thank you for Choosing Our Exam Portal, for further queries please contact our Admin.</p>
      <p class="text-center">
        <strong>Exam Result</strong>
      </p>
      <p>Score: {{currentScore}} out of {{totalQuestionScore}}</p>
      <p>Your Result: {{examResult}}%</p>
      <p>Score Needed To Pass Exam: {{scoreToPass}}%</p>
      <p v-if="isPassExam">
        Exam Status:
        <b-badge variant="success">Passed</b-badge>
      </p>
      <p v-else>
        Exam Status:
        <b-badge variant="danger">Failed</b-badge>
      </p>
      <p
        class="text-center"
        v-if="isPassExam"
      >
        <strong>Congratulations you have passed!</strong>
      </p>
      <p
        class="text-center"
        v-else
      >
        <strong>Please try again</strong>
      </p>
    </b-modal>

    <!-- invalid modal show -->
    <b-modal
      header-bg-variant="danger"
      id="modal-invalid"
      title="Alert!"
      ok-title="Go to question"
      @ok="onNavigateToInvalidQuestion"
    >
      <p class="text-danger">You Cannot Submit Blank Answer/s.</p>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import AppLoader from "../../components/Loader/Loader";
import _ from "lodash";
import { HTTP } from "../../utils/HTTP";

export default {
  name: "EmployeeUserExam",
  components: {
    AppLoader,
  },
  data () {
    return {
      inTransistion: false, // set to true when user selects answer and auto navigates to next question, used to hide or disable buttons
      pageIntroText: null,
      formTitle: {},
      startExam: false,
      currentQuestionIndex: 0,
      currentQuestion: null,
      currentAnswers: null,
      currentAnswerType: 1,
      currentExamAttempt: 0,
      enabled: true,
      dragging: false,
      countDown: 10,
      stopTimer: false,
      selected: "english",
      isInvalid: false,
      examTimeLimit: 0,
      examAttemptsToDate: 0,
      examAttemptsLimit: 0,
      isExamUnlimitedAttempts: false,
      selectedAnswers: [],
      questions: [],
      visitedQuestions: [],
      visitedQuestionsAndAnswered: [],
      fromButton: false,

      // stepper functionility
      noOfSteps: 0,
      selectedRadioAns: "",
      selectedCheckboxAns: [],
      selectedButtonAns: "",
      currentScore: 0,
      totalQuestionScore: 0,
      scoreToPass: 0,
      examResult: 0,
      isPassExam: false,

      // exam timer
      examPresentTime: null,
      showTimer: false,
      isAllowBlankAns: false,

      invalidQuestionIndex: null,
      taskId: null,
      pageStatus: null,
    };
  },
  mounted () {
    this.$store.state.selectedTaskType = localStorage.getItem( 'selected_task_type' );
    this.$store.state.employeeDashboardTabIndex = 0;
    this.taskId = this.$route.params.taskId;
    this.pageStatus = this.$route.params.readOnly;
    let formSchema = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
    let form = formSchema;
    this.formTitle = form.formTitle[this.selectedLanguage];
    this.formDescription = form.formDescription[this.selectedLanguage];
    this.pageIntroText = form.formIntroText[this.selectedLanguage];
    this.examTimeLimit = form.formConfiguration.exam.examTimeLimit;
    this.scoreToPass = form.formConfiguration.exam.examPassMark;
    this.examAttemptsLimit = form.formConfiguration.exam.examMaxAttempts;
    this.isExamUnlimitedAttempts =
      form.formConfiguration.exam.isUnlimitedAttempts;
    this.isAllowBlankAns = form.formConfiguration.exam.isAllowedEmpty || false;

    if (
      form.formConfiguration.exam.examUniqueAnswersPerAttempt &&
      form.formConfiguration.exam.examUniqueAnswersPerAttempt > 0
    ) {
      this.questions = this.getRandom(
        form.formSection[0].formElements,
        form.formConfiguration.exam.examUniqueAnswersPerAttempt
      );
    } else {
      this.questions = form.formSection[0].formElements;
    }

    this.currentQuestion = this.questions[
      this.currentQuestionIndex
    ].questionText[this.selectedLanguage];
    this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
    this.currentAnswerType = this.questions[
      this.currentQuestionIndex
    ].questionAnswerInputType;
    this.noOfSteps = this.questions.length;
    this.examPresentTime = this.examTimeLimit + ":" + 0;

    this.setSelectedAnswers();
    this.examAttemptsToDate = parseInt(
      localStorage.getItem( "examAttemptsToDate" )
    );
  },
  beforeDestroy () {
    this.examPresentTime = null;
    this.showTimer = false;
    this.onResetLocalData();
  },

  created () {
    window.stop();
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),
    ...mapState( ["selectedAnswersForExams"] ),
  },

  beforeRouteLeave ( to, from, next ) {
    if ( this.fromButton ) {
      next();
    } else {
      const answer = window.confirm(
        this.$t( "formLeaveAlertMessage" )
      );
      if ( answer ) {
        next();
      } else {
        next( false );
      }
    }
  },

  methods: {
    sanitizeHtml,
    ...mapActions( ["setLanguage"] ),

    leaving () {
      alert( "Leaving..." );
    },

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
    },

    startExamTimer () {
      let presentTime = this.examPresentTime;
      let timeArray = presentTime.split( /[:]+/ );
      let m = timeArray[0];
      let s = this.checkSecond( timeArray[1] - 1 );
      if ( s == 59 ) {
        m = m - 1;
      }

      if ( m < 0 ) {
        this.submitAnswers();
        this.examPresentTime = null;
        this.showTimer = false;
      } else {
        this.examPresentTime = m + ":" + s;
        setTimeout( this.startExamTimer, 1000 );
      }
    },

    checkSecond ( sec ) {
      if ( sec < 10 && sec >= 0 ) {
        sec = "0" + sec;
        if ( sec < 0 ) {
          sec = "59";
        }
        return sec;
      }
    },

    getRandom ( arr, n ) {
      var result = new Array( n ),
        len = arr.length,
        taken = new Array( len );
      if ( n > len )
        throw new RangeError( "getRandom: more elements taken than available" );
      while ( n-- ) {
        var x = Math.floor( Math.random() * len );
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     */
    shuffleArray ( array ) {
      for ( var i = array.length - 1; i > 0; i-- ) {
        var j = Math.floor( Math.random() * ( i + 1 ) );
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },

    setSelectedAnswers () {
      this.$store.state.selectedAnswersForExams = [];
      let allQuestions = _.cloneDeep( this.questions );
      for ( let i = 0; i < allQuestions.length; i++ ) {
        this.selectedAnswersForExams.push( {
          questionIndex: null,
          answer: null,
          answerIndex: null,
          viewed: false,
          question: null,
        } );
      }
    },

    autoNextQuestion () {
      return false;
    },

    startExamImmediately () {
      this.startExam = true;
      if ( this.examTimeLimit && this.examTimeLimit > 0 ) {
        this.showTimer = true;
        setTimeout( this.startExamTimer, 2000 );
      }

      this.$bvModal.hide( "modal-2" );
      let userType = localStorage.getItem( "userType" );
      if ( userType == 1 || userType == 2 ) {
        return;
      } else {
        this.updateAttempt();
      }
    },

    async updateAttempt () {
      /**
       * to logic here to select random questions
       */

      const URI = "api/v1/governance/training/employee/task/exam/attempt",
        headers = {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        };
      const Result = HTTP(
        "post",
        URI,
        { taskId: this.taskId, taskStatus: 1 },
        headers,
        null,
        true
      );
      return Result.then( ( response ) => {
        this.examAttemptsToDate++;

        localStorage.setItem(
          "examAttemptsToDate",
          parseInt( this.examAttemptsToDate )
        );
        localStorage.setItem(
          "examAttemptId",
          parseInt( response.data.attemptId )
        );
      } ).catch( ( err ) => {
        return err;
      } );
    },

    onTimerSet ( value ) {
      if ( value ) {
        this.stopTimer = false;
        this.examStartCountDownTimer();
      } else {
        this.stopTimer = true;
        this.countDown = 10;
        this.$bvModal.hide( "modal-2" );
      }
    },

    examStartCountDownTimer () {
      if ( this.countDown > 0 && !this.stopTimer ) {
        setTimeout( () => {
          this.countDown -= 1;
          this.examStartCountDownTimer();
        }, 1000 );
      }

      if ( this.countDown == 0 ) {
        if ( !this.startExam ) {
          this.startExam = true;
          this.updateAttempt();

          this.$bvModal.hide( "modal-2" );
        }
      }
    },

    setAnswer ( answer, answerIndex, type ) {
      let index = this.currentQuestionIndex;
      if ( type === "radio" ) {
        this.selectedRadioAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if ( type === "checkbox" ) {
        this.selectedCheckboxAns = answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      if ( type === "button" ) {
        this.selectedButtonAns = answer.answer;
        this.selectedAnswersForExams[index].questionIndex = index;
        this.selectedAnswersForExams[index].answer = answer.answer;
        this.selectedAnswersForExams[index].answerIndex = answerIndex;
        this.selectedAnswersForExams[index].viewed = true;
        this.selectedAnswersForExams[index].question = this.questions[
          this.currentQuestionIndex
        ];
      }
      this.selectedAnswersForExams[index].viewed = true;
    },

    nextQuestion () {
      if ( this.currentQuestionIndex + 1 < this.questions.length ) {
        this.currentQuestionIndex++;
        this.currentQuestion = this.questions[
          this.currentQuestionIndex
        ].questionText[this.selectedLanguage];
        this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
        this.currentAnswerType = this.questions[
          this.currentQuestionIndex
        ].questionAnswerInputType;

        this.selectedRadioAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
        this.selectedCheckboxAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || [];
        this.selectedButtonAns =
          this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
      }
    },

    setScoreToAnswer () {
      this.currentScore = 0;
      this.totalQuestionScore = 0;
      let deep = _.cloneDeep( this.selectedAnswersForExams );
      deep.map( ( aa ) => {
        aa.question &&
          aa.question.answers.length &&
          aa.question.answers.map( ( ans ) => {
            if ( aa.answer === ans.answer && ans.isCorrectAnswer === "Yes" ) {
              this.currentScore =
                parseInt( this.currentScore ) +
                parseInt( aa.question.questionScore );
            }
          } );
      } );
    },

    calculateScore () {
      this.setScoreToAnswer();
      this.questions.map( ( score ) => {
        this.totalQuestionScore =
          this.totalQuestionScore + parseInt( score.questionScore );
      } );
      let totalScore = this.totalQuestionScore,
        obtainScore = this.currentScore,
        scoreToPass = this.scoreToPass;

      let result = ( obtainScore / totalScore ) * 100;
      this.examResult = Math.round( result );
      this.isPassExam = this.examResult >= scoreToPass ? true : false;
    },

    previousQuestion () {
      this.currentQuestionIndex--;
      this.setAnswer();
      this.currentQuestion = this.questions[
        this.currentQuestionIndex
      ].questionText[this.selectedLanguage];
      this.currentAnswers = this.questions[this.currentQuestionIndex].answers;
      this.currentAnswerType = this.questions[
        this.currentQuestionIndex
      ].questionAnswerInputType;
      this.selectedRadioAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
      this.selectedCheckboxAns = this.selectedAnswersForExams[
        this.currentQuestionIndex
      ].answer;
      this.selectedButtonAns =
        this.selectedAnswersForExams[this.currentQuestionIndex].answer || "";
    },

    onBack () {
      if ( this.pageStatus == "1" ) {
        this.fromButton = true;
        this.$router.push( "/dashboard" );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },

    onValidateExam () {
      let isValid = false;
      outerLoop: for ( let i = 0; i < this.selectedAnswersForExams.length; i++ ) {
        if ( !this.selectedAnswersForExams[i].answer ) {
          this.invalidQuestionIndex = i;
          isValid = false;
          this.$bvModal.show( "modal-invalid" );
          break outerLoop;
        }
        isValid = true;
      }
      if ( isValid ) {
        this.$bvModal.show( "modal-1" );
      }
    },

    onNavigateToInvalidQuestion () {
      outerLoop: for ( let i = 0; i < this.selectedAnswersForExams.length; i++ ) {
        if ( !this.selectedAnswersForExams[i].answer ) {
          this.currentQuestionIndex = this.invalidQuestionIndex + 1;
          this.previousQuestion();
          break outerLoop;
        }
      }
    },

    submitAnswers ( e ) {
      let taskId = localStorage.getItem( "taskId" );
      let attemptId = localStorage.getItem( "examAttemptId" );
      let userId = localStorage.getItem( "userId" );

      this.calculateScore();
      let examResult = {
        attemptId: attemptId,
        id: taskId,
        totalQuestionScore: this.totalQuestionScore,
        obtainResultAsPercentage: this.examResult,
        examStatus: this.isPassExam,
        userId: userId,
        examAttemptsLimit: this.examAttemptsLimit,
        attmptsRemaining: this.examAttemptsToDate,
        isUnlimitedAttempts: this.isExamUnlimitedAttempts,
      };

      const URI = "api/v1/governance/training/employee/task/submitexam",
        headers = {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        };
      const Result = HTTP(
        "post",
        URI,
        {
          answers: this.selectedAnswersForExams,
          examResult,
          id: taskId,
          attemptId: attemptId,
        },
        headers,
        null,
        true
      );
      return Result.then( ( response ) => {
        if ( e == "only" ) {
          if ( this.pageStatus == "1" ) {
            this.fromButton = true;
            this.$router.push( "/dashboard" );
          } else {
            this.$router.push( this.$store.state.selectedTaskType );
          }
        } else {
          this.fromButton = true;
          this.$bvModal.show( "modal-submitted" );
        }
      } ).catch( ( err ) => {
        return err;
      } );
    },

    onCancelExam () {
      this.submitAnswers( "only" );
      // this.$router.push("/dashboard");
    },
  },
};
</script>

<style>
.exam-card-header {
  padding: 0.75rem 1.25rem !important;
  margin-bottom: 0 !important;
  background-color: rgb(0 0 0 / 3%) !important;
  border-bottom: 1px solid rgb(0 0 0 / 13%) !important;
}
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}
.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}
.animate-slide-to-right {
  position: relative;
  animation: toRight 1s;
  opacity: 1;
}
@keyframes fromLeft {
  from {
    left: -5px;
    opacity: 0;
  }
  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }
  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  background: #33dd97;
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  background: #33dd97;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 6.9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 25px solid #33dd97;
  border-left: 12px solid transparent;
}
</style>
